import React, { useState, useMemo } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  BtnModalTable,
  BtnOutlineGreen,
  BtnOutlineRed,
} from '../../styled-components';
import {
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

function ActionsField({ data, profile, updateContacts }) {
  const [t] = useTranslation('MARKETING');
  const [{ newToken } = {}] = useAuth();
  const alert = useAlert();

  const [modal, setModal] = useState(false);

  const INITIAL_CONTACT_STATE = useMemo(
    () => ({
      id_contact: data.id_contact || '',
      nome: data.nome || '',
      cognome: data.cognome || '',
      azienda: data.azienda === '1' ? true : false,
      nome_azienda: data.nome_azienda || '',
      email: data.email || '',
      telefono: data.telefono || '',
      cap: data.cap || '',
      provincia: data.provincia || '',
      citta: data.citta || '',
      consenso_termini_condizioni:
        data.consenso_termini_condizioni === '1' ? true : false,
      consenso_privacy: data.consenso_privacy === '1' ? true : false,
      consenso_marketing: data.consenso_marketing === '1' ? true : false,
      consenso_terze_parti: data.consenso_terze_parti === '1' ? true : false,
    }),
    [data]
  );

  const [formValues, setFormValues] = useState({
    ...INITIAL_CONTACT_STATE,
  });

  const [formErrors, setFormErrors] = useState({
    id_contact: false,
    nome: false,
    cognome: false,
    azienda: false,
    nome_azienda: false,
    email: false,
    telefono: false,
    cap: false,
    provincia: false,
    citta: false,
    consenso_termini_condizioni: false,
    consenso_privacy: false,
    consenso_marketing: false,
    consenso_terze_parti: false,
  });

  const toggle = () => {
    setModal(!modal);
    setFormValues({
      ...INITIAL_CONTACT_STATE,
    });
  };

  function onInputChange({ target, uppercase }) {
    setFormValues((state) => ({
      ...state,
      [target.name]:
        target.type === 'radio'
          ? target.value === '1'
          : uppercase
          ? target.value?.toUpperCase()
          : target.value,
    }));
  }

  const onContactUpdate = async () => {
    const {
      id_contact,
      nome,
      cognome,
      azienda,
      nome_azienda,
      email,
      telefono,
      cap,
      provincia,
      citta,
    } = formValues;

    const errors = {};

    if (!nome || nome === '') errors.nome = true;
    if (!cognome || cognome === '') errors.cognome = true;
    if (Boolean(azienda) && (!nome_azienda || nome_azienda === ''))
      errors.nome_azienda = true;
    if (!email || email === '') errors.email = true;
    if (Object.keys(errors).length) {
      return setFormErrors(errors);
    }

    updateContacts(formValues);
    toggle();
  };

  function listenForEscapeEvent() {
    document.addEventListener('keydown', ({ key }) => {
      if (key === 'Escape') toggle();
    });
  }

  const {
    nome,
    cognome,
    nome_azienda,
    email,
    telefono,
    cap,
    provincia,
    citta,
  } = useMemo(() => formValues, [formValues]);

  return (
    <React.Fragment>
      <BtnModalTable
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          toggle();
        }}
      >
        {t('EDIT')}
      </BtnModalTable>

      <Modal
        isOpen={modal}
        className="new-customerExtra-modal"
        onOpened={listenForEscapeEvent}
      >
        <ModalHeader toggle={toggle}>{t('EDIT_CONTACT')}</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onContactUpdate(formValues);
          }}
        >
          <ModalBody>
            <Row>
              <Col sm="12">
                <Row>
                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('NAME')}</Label>
                      <Input
                        type="text"
                        name="nome"
                        value={nome}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('SURNAME')}</Label>
                      <Input
                        type="text"
                        name="cognome"
                        value={cognome}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col sm="12" md="6" lg="2">
                    <FormGroup>
                      <Label>{t('IS_BUSINESS')}</Label>
                      <div onChange={onInputChange}>
                        <CustomInput
                          type="radio"
                          id="commercialRadio1"
                          label="SI"
                          name="azienda"
                          value="1"
                          inline
                          checked={formValues.azienda === true}
                        />
                        <CustomInput
                          type="radio"
                          id="commercialRadio2"
                          label="NO"
                          name="azienda"
                          value="0"
                          inline
                          checked={!formValues.azienda}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('BUSINESS_NAME')}</Label>
                      <Input
                        type="text"
                        name="nome_azienda"
                        value={nome_azienda}
                        onChange={onInputChange}
                        disabled={!formValues.azienda}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('EMAIL')}</Label>
                      <Input
                        type="text"
                        name="email"
                        value={email}
                        onChange={onInputChange}
                        disabled={true}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('TELEPHONE')}</Label>
                      <Input
                        type="text"
                        name="telefono"
                        value={telefono}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('CAP')}</Label>
                      <Input
                        type="text"
                        name="cap"
                        value={cap}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('PROVINCE')}</Label>
                      <Input
                        type="text"
                        name="provincia"
                        value={provincia}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('CITY')}</Label>
                      <Input
                        type="text"
                        name="citta"
                        value={citta}
                        onChange={onInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col sm="12" md="6" lg="2">
                    <FormGroup>
                      <Label>{t('TERMS_AND_CONDITION')}</Label>
                      <div onChange={onInputChange}>
                        <CustomInput
                          type="radio"
                          id="commercialRadio3"
                          label="SI"
                          name="consenso_termini_condizioni"
                          value="1"
                          inline
                          checked={
                            formValues.consenso_termini_condizioni === true
                          }
                        />
                        <CustomInput
                          type="radio"
                          id="commercialRadio4"
                          label="NO"
                          name="consenso_termini_condizioni"
                          value="0"
                          inline
                          checked={!formValues.consenso_termini_condizioni}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col sm="12" md="6" lg="2">
                    <FormGroup>
                      <Label>{t('PRIVACY')}</Label>
                      <div onChange={onInputChange}>
                        <CustomInput
                          type="radio"
                          id="commercialRadio5"
                          label="SI"
                          name="consenso_privacy"
                          value="1"
                          inline
                          checked={formValues.consenso_privacy === true}
                        />
                        <CustomInput
                          type="radio"
                          id="commercialRadio6"
                          label="NO"
                          name="consenso_privacy"
                          value="0"
                          inline
                          checked={!formValues.consenso_privacy}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col sm="12" md="6" lg="2">
                    <FormGroup>
                      <Label>{t('MARKETING')}</Label>
                      <div onChange={onInputChange}>
                        <CustomInput
                          type="radio"
                          id="commercialRadio7"
                          label="SI"
                          name="consenso_marketing"
                          value="1"
                          inline
                          checked={formValues.consenso_marketing === true}
                        />
                        <CustomInput
                          type="radio"
                          id="commercialRadio8"
                          label="NO"
                          name="consenso_marketing"
                          value="0"
                          inline
                          checked={!formValues.consenso_marketing}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col sm="12" md="6" lg="2">
                    <FormGroup>
                      <Label>{t('THIRD_PARTS')}</Label>
                      <div onChange={onInputChange}>
                        <CustomInput
                          type="radio"
                          id="commercialRadio9"
                          label="SI"
                          name="consenso_terze_parti"
                          value="1"
                          inline
                          checked={formValues.consenso_terze_parti === true}
                        />
                        <CustomInput
                          type="radio"
                          id="commercialRadio10"
                          label="NO"
                          name="consenso_terze_parti"
                          value="0"
                          inline
                          checked={!formValues.consenso_terze_parti}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default ActionsField;
